import { useState } from "react";
import emailjs from "emailjs-com";
import React from "react";

const initialState = {
  name: "",
  email: "",
  message: "",
};

export const Contact = (props) => {
  const [{ name, email, message }, setState] = useState(initialState);
  const [successMessage, setSuccessMessage] = useState("");

  const handleChange = (e) => {
    const { name, value } = e.target;
    setState((prevState) => ({ ...prevState, [name]: value }));
  };

  const clearState = () => setState({ ...initialState });

  const handleSubmit = (e) => {
    e.preventDefault();

    emailjs
      .sendForm("service_u1z35xf", "template_jxgaefu", e.target, "WUfIrZrSQh-kQI2e0")
      .then(
        (result) => {
          console.log(result.text);
          setSuccessMessage("Your message has been sent!");
          clearState();
        },
        (error) => {
          console.log(error.text);
          setSuccessMessage("There was an error sending your message.");
        }
      );
  };

  return (
    <div>
      <div id="contact">
        <div className="container">
          <div className="col-md-8">
            <div className="row">
              <div className="section-title">
                <h2>Get In Touch</h2>
                <p>
                  Please fill out the form below to send us an email and we will
                  get back to you as soon as possible.
                </p>
              </div>
              <form name="sentMessage" validate="true" onSubmit={handleSubmit}>
                <div className="row">
                  <div className="col-md-6">
                    <div className="form-group">
                      <input
                        type="text"
                        id="name"
                        name="name"
                        className="form-control"
                        placeholder="Name"
                        required
                        value={name}
                        onChange={handleChange}
                      />
                      <p className="help-block text-danger"></p>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <input
                        type="email"
                        id="email"
                        name="email"
                        className="form-control"
                        placeholder="Email"
                        required
                        value={email}
                        onChange={handleChange}
                      />
                      <p className="help-block text-danger"></p>
                    </div>
                  </div>
                </div>
                <div className="form-group">
                  <textarea
                    name="message"
                    id="message"
                    className="form-control"
                    rows="4"
                    placeholder="Message"
                    required
                    value={message}
                    onChange={handleChange}
                  ></textarea>
                  <p className="help-block text-danger"></p>
                </div>
                <div id="success"></div>
                <button type="submit" className="btn btn-custom btn-lg">
                  Send Message
                </button>
              </form>
              {successMessage && (
                <div className="alert alert-success" style={{ marginTop: "20px" }}>
                  {successMessage}
                </div>
              )}
            </div>
          </div>
          <div className="col-md-3 col-md-offset-1 contact-info">
            {/* Contact Info */}
            <div className="contact-item">
              <h3>Contact Info</h3>
            </div>
            <div className="contact-item">
              <p>
                <span>
                  <i className="fa fa-whatsapp"></i> WhatsApp
                </span>{" "}
                <a href={`https://wa.me/972546945333`} style={{ color: "white" }} target="_blank" rel="noopener noreferrer">
                  {props.data ? props.data.phone : "loading"}
                </a>
              </p>
              <p>
                <a href={`https://wa.me/972545217456`} style={{ color: "white" }} target="_blank" rel="noopener noreferrer">
                  {props.data ? props.data.phone2 : "loading"}
                </a>
              </p>
            </div>
            <div className="contact-item">
              <p>
                <span>
                  <i className="fa fa-envelope-o"></i> Email
                </span>{" "}
                <a href={`mailto:${props.data ? props.data.email : ""}`} style={{ color: "white" }}>
                  {props.data ? props.data.email : "loading"}
                </a>
              </p>
              <p>
                <a href={`mailto:${props.data ? props.data.email2 : ""}`} style={{ color: "white" }}>
                  {props.data ? props.data.email2 : "loading"}
                </a>
              </p>
            </div>
            <div className="contact-item">
              <p>
                <span>
                  <i className="fa fa-phone"></i> Phone
                </span>{" "}
                <a href={`tel:${props.data ? props.data.phone : ""}`} style={{ color: "white" }}>
                  {props.data ? props.data.phone : "loading"}
                </a>
              </p>
              <p>
                <a href={`tel:${props.data ? props.data.phone2 : ""}`} style={{ color: "white" }}>
                  {props.data ? props.data.phone2 : "loading"}
                </a>
              </p>
            </div>
            <div className="contact-item">
              <p>
                <span>
                  <i className="fa fa-globe"></i> Website
                </span>{" "}
                <a href="https://rr-web.net/" style={{ color: "white" }} target="_blank" rel="noopener noreferrer">
                  rr-web
                </a>
              </p>
            </div>
          </div>
        </div>
      </div>
      <div id="footer">
        <div className="container text-center">
        <p style={{ margin: 0 }}>
  <a href="https://www.rr-web.net/" target="_blank" rel="noopener noreferrer" style={{ textDecoration: "none", color: "inherit" }}>
    &copy; 2024 R & R-Net. All rights reserved.
  </a>
</p>
          <div style={{ display: "inline-block" }}>
            <a href="https://roeinizri.com/terms-of-use.html" target="_blank" rel="noopener noreferrer" style={{ margin: "0 10px" }}>Terms of Use</a>  |
            <a href="https://roeinizri.tawk.help" target="_blank" rel="noopener noreferrer" style={{ margin: "0 10px" }}>Help</a>
          </div>
        </div>
      </div>
    </div>
  );
};
